import {ListItemProps} from 'component/partial/MetricSection/MetricSection';

import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_EXPIRING_COACH_RENEWAL,
  REPORT_NOT_CERTIFIED,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {
  NeedAttentionSectionHookReturn,
  NeedAttentionSectionProps,
} from './NeedAttentionSection.types';

export const useNeedAttentionSection = ({
  expiringCoachRenewal = 0,
  notCertified = 0,
  onShowReport = () => {},
  onShowInfoPopover = () => {},
}: NeedAttentionSectionProps): NeedAttentionSectionHookReturn => {
  const {tt, ts} = useTranslation('screen.teams.section.needAttentionSection');

  const listItems: ListItemProps[] = [
    {
      label: tt('noCertified', 'Not Certified'),
      value: notCertified,
      recordsName: REPORT_NOT_CERTIFIED,
      testID: MetricsSection.metricNotCertified,
    },
    {
      label: tt('expiringCoachRenewals', 'Expiring Coach Renewals'),
      value: expiringCoachRenewal,
      recordsName: REPORT_EXPIRING_COACH_RENEWAL,
      testID: MetricsSection.metricExpiringCoachRenewals,
    },
  ];

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Need Attention'),
      body: tt(
        'info.body',
        'These Coaches might need attention. Check out who may be able to improve their Coaching knowledge by becoming Certified AND those Coaches who are due to renew their businesses (so that they can keep Coaching and helping others).',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {
    onItemPress,
    onInfoPress,
    listItems,
    tt,
    ts,
  };
};
